import React, { Component } from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { FaUser, FaEdit, FaWindowClose } from 'react-icons/fa';
import { connect } from 'react-redux';
import { setUser, updateUser, createUser, getUser } from 'context/actions/index';
import UserView from './UserView';
import UserForm from './UserForm';
import axios, {api} from "hooks/axios";

class UserProfile extends Component {
  data = JSON.parse(localStorage["user-data"]);

  constructor(props) {
    super(props);
    this.state = {
      userProfile: {
        name: '',
        phone: '',
        dob: null,
        profession: '',
        sex: 0,
        location: '',
        marriage: 0,
        smoking: 0,
        bio: '',
        action: ''
      },
      userData:{},
      provinces: [],
      isEditing: false,
      loading: false,
      error: null,
      formErrors: {},
      submitLoading: false
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser = async () => {
    this.setState({ loading: true });
    try {
      const [userResponse, provinceResponse] = await Promise.all([
        this.props.getUser(this.data.user_id),
        axios.get('https://www.emsifa.com/api-wilayah-indonesia/api/provinces.json')
      ]);
      console.log(userResponse.data[0])
      this.setState({ provinces: provinceResponse.data });

      if (userResponse.data.length > 0) {
        const user = userResponse.data[0];
        this.setState({
          userProfile: {
            name: user.name || '',
            phone: user.phone || '',
            dob: user.dob ? new Date(user.dob) : null,
            profession: user.profession || '',
            sex: user.sex || 0,
            location: user.location || '',
            marriage: user.marriage || 0,
            smoking: user.smoking || 0,
            bio: user.bio || '',
            action: 'update'
          }
        });
        this.setState({userData : this.state.userProfile})
      } else {
        this.setState({
          userProfile: {
            ...this.state.userProfile,
            action: 'create'
          },
          isEditing: true
        });
      }
    } catch (error) {
      this.setState({ error: 'Failed to load user data' });
    } finally {
      this.setState({ loading: false });
    }
  };

  toggleEdit = () => {
    this.setState(prevState => ({ 
      isEditing: !prevState.isEditing,
      formErrors: {}
    }));
      this.setState({userProfile : this.state.userData})
  };

  updateUserProfile = (updates) => {
    this.setState(prevState => ({
      userProfile: {
        ...prevState.userProfile,
        ...updates
      }
    }));
  };

  getProvinceName = (id) => {
    const province = this.state.provinces.find(p => p.id === id);
    return province ? province.name : 'Not selected';
  };

  validateForm = () => {
    const errors = {};
    const { userProfile } = this.state;

    if (!userProfile.name?.trim()) errors.name = 'Name is required';
    if (!userProfile.phone?.trim()) errors.phone = 'Phone is required';
    if (!userProfile.dob) errors.dob = 'Date of birth is required';
    if (!userProfile.profession?.trim()) errors.profession = 'Profession is required';
    if (!userProfile.location) errors.location = 'Location is required';
    if (!userProfile.bio?.trim()) errors.bio = 'Bio is required';

    this.setState({ formErrors: errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!this.validateForm()) return;

    this.setState({ submitLoading: true });

    try {
      const userData = {
        user_id: this.data.user_id,
        ...this.state.userProfile,
        dob: this.state.userProfile.dob?.toISOString().split('T')[0]
      };

      if (this.state.userProfile.action === 'create') {
        await this.props.createUser(userData);
      } else {
        await this.props.updateUser(userData);
      }

      // Dispatch setUser action to update Redux store
      this.props.setUser(userData);

      this.setState({ 
        isEditing: false,
        submitLoading: false
      });
      
      // Refresh data
      await this.getUser();
      
    } catch (error) {
      this.setState({ 
        formErrors: { submit: 'Something went wrong. Please try again.' },
        submitLoading: false
      });
    }
  };

  render() {
    const { isEditing, loading, error, formErrors, submitLoading, userProfile, provinces } = this.state;

    if (loading) {
      return (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <Alert variant="danger" className="my-5">
          Error loading user profile: {error}
        </Alert>
      );
    }

    return (
      <Card className="shadow-lg border-0 modern-user-card">
        <Card.Header className="bg-gradient-primary text-white py-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="h4 mb-0">
                <FaUser size={32} className="me-3" />
                User Profile
              </h2>
              <p className="mb-0 opacity-75">{this.data.user_email}</p>
            </div>
            <Button
              variant={isEditing ? "outline-light" : "light"}
              onClick={this.toggleEdit}
              disabled={submitLoading}
            >
              {isEditing ? <FaWindowClose size={16} className="me-2" /> : <FaEdit size={16} className="me-2" />}
              {isEditing ? 'Cancel' : 'Edit Profile'}
            </Button>
          </div>
        </Card.Header>

        <Card.Body className="p-4">
          {!isEditing ? (
            <UserView
              userProfile={userProfile}
              userData={this.data}
              getProvinceName={this.getProvinceName}
            />
          ) : (
            <UserForm
              userData={this.data}
              userProfile={userProfile}
              provinces={provinces}
              errors={formErrors}
              loading={submitLoading}
              onSubmit={this.handleSubmit}
              onUpdate={this.updateUserProfile}
              onCancel={this.toggleEdit}
            />
          )}
        </Card.Body>
      </Card>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
    createUser: (user) => dispatch(createUser(user)),
    updateUser: (user) => dispatch(updateUser(user)),
    getUser: (user) => dispatch(getUser(user))
  };
};

export default connect(null, mapDispatchToProps)(UserProfile);
